<template>
  <div class="property-right-registration-container">
    <!-- 查询条件：新增费用类型（房租/采暖）查询项 -->
    <el-card class="search-wrapper">
      <div slot="header" class="flex justify-between">
        <span>计算规则查询</span>
        <!-- 新增：更多查询条件切换按钮 -->
        <el-button
          type="text"
          @click="toggleMoreCondition"
          icon="el-icon-arrow-down"
          :icon-class="
            showMoreCondition ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
          "
        >
          {{ showMoreCondition ? "收起条件" : "更多条件" }}
        </el-button>
      </div>
      <el-row :gutter="20">
        <!-- 规则名称查询 -->
        <el-col :span="6">
          <el-input
            v-model="searchForm.ruleName"
            placeholder="请输入规则名称"
            clearable
            @keyup.enter="handleSearch"
          />
        </el-col>
        <!-- 房产类型查询（原有逻辑保留） -->
        <el-col :span="6">
          <el-select
            v-model="searchForm.propertyType"
            placeholder="请选择房产类型"
            style="width: 100%"
            clearable
          >
            <el-option
              v-for="(item, index) in propertyTypeOptions"
              :key="index"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-col>
        <!-- 新增：费用类型查询（房租/采暖） -->
        <el-col :span="6">
          <el-select
            v-model="searchForm.feeType"
            placeholder="请选择费用类型"
            style="width: 100%"
            clearable
          >
            <el-option label="房租" value="rent" />
            <el-option label="采暖" value="heating" />
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="handleSearch"> 查询 </el-button>
          <el-button @click="handleReset" class="ml-2"> 重置 </el-button>
        </el-col>
      </el-row>
      <!-- 更多查询条件 -->
      <el-row :gutter="20" v-if="showMoreCondition" class="mt-20">
        <el-col :span="6">
          <el-select
            v-model="searchForm.isEnabled"
            placeholder="请选择生效状态"
            style="width: 100%"
            clearable
          >
            <el-option label="启用" value="1" />
            <el-option label="禁用" value="0" />
          </el-select>
        </el-col>
        <!-- 新增：创建时间范围查询 -->
        <el-col :span="12">
          <el-date-picker
            v-model="searchForm.createTimeRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="YYYY-MM-DD"
            value-format="YYYY-MM-DD"
            style="width: 100%"
          />
        </el-col>
      </el-row>
    </el-card>

    <!-- 数据列表：新增费用类型列 -->
    <el-card class="list-wrapper">
      <div slot="header" class="flex justify-between items-center">
        <span>计算规则列表</span>
        <el-button type="primary" size="small" @click="handleAdd">
          <i class="el-icon-plus" />
          新增
        </el-button>
      </div>

      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
        :empty-text="loading ? '加载中...' : '暂无计算规则数据'"
        element-loading-text="正在加载数据..."
        element-loading-background="rgba(255, 255, 255, 0.8)"
        @row-click="handleRowClick"
      >
        <!-- 序号列 -->
        <el-table-column type="index" label="序号" align="center" width="60" />
        <!-- 规则名称 -->
        <el-table-column
          prop="ruleName"
          label="规则名称"
          align="center"
          min-width="120"
        />
        <!-- 房产类型（原有） -->
        <el-table-column label="房产类型" align="center" width="120">
          <template slot-scope="scope">
            {{
              scope.row.propertyTypeName ||
              getPropertyTypeLabel(scope.row.propertyType)
            }}
          </template>
        </el-table-column>
        <!-- 新增：费用类型列（房租/采暖） -->
        <el-table-column label="费用类型" align="center" width="120">
          <template slot-scope="scope">
            {{ getFeeTypeLabel(scope.row.feeType) }}
          </template>
        </el-table-column>
        <!-- 每平米价格 -->
        <el-table-column label="每平米价格" align="center" width="120">
          <template slot-scope="scope">
            ¥{{ Number(scope.row.pricePerSqm || 0).toFixed(2) }} 元/㎡
          </template>
        </el-table-column>
        <!-- 生效状态 -->
        <el-table-column label="生效状态" align="center" width="120">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.isEnabled === '1' ? 'success' : 'danger'"
              size="mini"
            >
              {{ scope.row.isEnabled === "1" ? "启用" : "禁用" }}
            </el-tag>
          </template>
        </el-table-column>
        <!-- 创建时间 -->
        <el-table-column
          prop="createTime"
          label="创建时间"
          align="center"
          width="180"
        >
          <template slot-scope="scope">
            {{ formatDate(scope.row.createTime) }}
          </template>
        </el-table-column>
        <!-- 关联房屋数 -->
        <el-table-column label="关联房屋数" align="center" width="150">
          <template slot-scope="scope">
            <span class="relation-count">
              {{ scope.row.listCount || 0 }} 个
            </span>
            <el-button
              size="mini"
              type="text"
              @click.stop="handleRelateHouse(scope.row)"
              :disabled="!scope.row.ruleId"
            >
              查看关联
            </el-button>
          </template>
        </el-table-column>
        <!-- 规则描述 -->
        <el-table-column
          prop="ruleDesc"
          label="规则描述"
          align="center"
          min-width="150"
        >
          <template slot-scope="scope">
            {{ scope.row.ruleDesc || "-" }}
          </template>
        </el-table-column>
        <!-- 操作列 -->
        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click.stop="handleEdit(scope.row)"
              :disabled="!scope.row.ruleId"
            >
              编辑
            </el-button>
            <el-button
              size="mini"
              type="danger"
              @click.stop="handleDelete(scope.row)"
              class="ml-2"
              :disabled="!scope.row.ruleId"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        v-if="pagination.total > 0"
        class="mt-20"
        :current-page="pagination.current"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pagination.size"
        :total="pagination.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
      />

      <!-- 无数据提示 -->
      <div v-if="!loading && pagination.total === 0" class="no-data-tip">
        <i class="el-icon-empty"></i>
        <p>暂无符合条件的计算规则数据</p>
      </div>
    </el-card>

    <!-- 子组件 -->
    <add-calc-rule ref="addForm" @success="handleSuccess" />
    <edit-calc-rule ref="editForm" @success="handleSuccess" />
    <delete-calc-rule ref="deleteForm" @success="handleSuccess" />
    <relate-property-dialog
      ref="relatePropertyDialog"
      :rule-info="currentRuleInfo"
      @close="handleRelateDialogClose"
    />
  </div>
</template>

<script>
import { queryCalcRules } from "@/api/community/calcRuleApi";
import AddCalcRule from "@/components/calcRule/addCalcRule";
import EditCalcRule from "@/components/calcRule/editCalcRule";
import DeleteCalcRule from "@/components/calcRule/deleteCalcRule";
import RelatePropertyDialog from "@/components/calcRule/relatePropertyDialog";
import { getCommunityId } from "@/api/community/communityApi";
export default {
  name: "CalculationRuleList",
  components: {
    AddCalcRule,
    EditCalcRule,
    DeleteCalcRule,
    RelatePropertyDialog,
  },
  data() {
    return {
      loading: false,
      showMoreCondition: false,
      // 搜索条件：新增 feeType（费用类型）
      searchForm: {
        ruleName: "",
        propertyType: "",
        isEnabled: "",
        feeType: "",
        createTimeRange: [],
      },
      currentRuleInfo: {},
      tableData: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0,
      },
      // 房产类型映射
      propertyTypeOptions: [
        { value: "10", label: "住宅" },
        { value: "20", label: "商业" },
        { value: "30", label: "工业" },
        { value: "40", label: "商铺" },
        { value: "50", label: "其他" },
      ],
      // 费用类型映射
      feeTypeOptions: [
        { value: "rent", label: "房租" },
        { value: "heating", label: "采暖" },
      ],
    };
  },
  created() {
    this.communityId = getCommunityId();
    this.getList();
  },
  methods: {
    /**
     * 获取计算规则列表
     */
    async getList() {
      try {
        this.loading = true;
        const { current, size } = this.pagination;
        console.log(this.communityId, "this.communityId");
        const params = {
          page: current,
          row: size,
          communityId: this.communityId,
          ruleName: this.searchForm.ruleName.trim() || undefined,
          propertyType: this.searchForm.propertyType || undefined,
          isEnabled: this.searchForm.isEnabled || undefined,
          feeType: this.searchForm.feeType || undefined,
        };
        if (
          this.searchForm.createTimeRange &&
          this.searchForm.createTimeRange.length === 2
        ) {
          params.startTime = this.searchForm.createTimeRange[0];
          params.endTime = this.searchForm.createTimeRange[1];
        }
        const res = await queryCalcRules(params);
        if (res.code === 0) {
          this.tableData = res.data || [];
          this.pagination.total = res.total || 0;
        } else {
          this.$message.error(res.msg || "获取计算规则列表失败");
          this.tableData = [];
          this.pagination.total = 0;
        }
      } catch (error) {
        console.error("获取计算规则列表失败:", error);
        this.$message.error("网络异常，获取计算规则列表失败，请重试");
        this.tableData = [];
        this.pagination.total = 0;
      } finally {
        this.loading = false;
      }
    },

    /**
     * 查看关联房屋弹窗
     */
    handleRelateHouse(rule) {
      if (!rule || !rule.ruleId) {
        this.$message.error("规则信息不完整，无法查看关联");
        return;
      }
      this.currentRuleInfo = {
        ruleId: rule.ruleId,
        ruleName: rule.ruleName || "未命名规则",
        pricePerSqm: rule.pricePerSqm || 0,
        totalValue: rule.totalValue || 0,
        feeType: rule.feeType || "",
      };
      this.$nextTick(() => {
        if (this.$refs.relatePropertyDialog) {
          this.$refs.relatePropertyDialog.open();
        } else {
          this.$message.warning("关联房屋组件加载失败，请刷新页面");
        }
      });
    },

    /**
     * 关闭关联房屋弹窗回调
     */
    handleRelateDialogClose() {
      this.currentRuleInfo = {};
      this.getList();
    },

    /**
     * 房产类型文字转换
     */
    getPropertyTypeLabel(value) {
      if (!value) return "-";
      const target = this.propertyTypeOptions.find(
        (item) => item.value === value,
      );
      return target ? target.label : "未知类型";
    },

    /**
     * 费用类型文字转换
     */
    getFeeTypeLabel(value) {
      if (!value) return "-";
      const target = this.feeTypeOptions.find((item) => item.value === value);
      return target ? target.label : "未知类型";
    },

    /**
     * 日期格式化
     */
    formatDate(dateStr) {
      if (!dateStr) return "-";
      try {
        const date = new Date(dateStr);
        const m = String(date.getMonth() + 1).padStart(2, "0");
        const d = String(date.getDate()).padStart(2, "0");
        return `${date.getFullYear()}-${m}-${d}`;
      } catch (e) {
        return dateStr;
      }
    },

    /**
     * 查询按钮
     */
    handleSearch() {
      this.pagination.current = 1;
      this.getList();
    },

    /**
     * 重置查询条件
     */
    handleReset() {
      this.searchForm = {
        ruleName: "",
        propertyType: "",
        isEnabled: "",
        feeType: "",
        createTimeRange: [],
      };
      this.handleSearch();
    },

    /**
     * 展开/收起更多查询条件
     */
    toggleMoreCondition() {
      this.showMoreCondition = !this.showMoreCondition;
    },

    /**
     * 新增规则
     */
    handleAdd() {
      this.$nextTick(() => {
        if (this.$refs.addForm) this.$refs.addForm.open();
        else this.$message.warning("新增组件加载失败，请刷新页面");
      });
    },

    /**
     * 编辑规则
     */
    handleEdit(row) {
      if (!row || !row.ruleId) {
        this.$message.error("规则ID不存在，无法编辑");
        return;
      }
      this.$nextTick(() => {
        if (this.$refs.editForm) this.$refs.editForm.open(row);
        else this.$message.warning("编辑组件加载失败，请刷新页面");
      });
    },

    /**
     * 删除规则（核心：区分有无关联房屋提示）
     */
    handleDelete(row) {
      if (!row || !row.ruleId) {
        this.$message.error("规则ID不存在，无法删除");
        return;
      }
      const count = Number(row.listCount || 0);
      // 存在关联房屋：弹出风险提示
      if (count > 0) {
        this.$alert(
          `当前规则已关联${count}套房屋，删除后该规则永久失效，绑定房屋将不再使用本计费标准，请谨慎操作！`,
          "风险警告",
          {
            type: "warning",
            confirmButtonText: "仍要删除",
            callback: () => {
              this.$nextTick(() => this.$refs.deleteForm.open(row));
            },
          },
        );
      } else {
        // 无关联房屋，直接打开删除弹窗
        this.$nextTick(() => this.$refs.deleteForm.open(row));
      }
    },

    /**
     * 新增/编辑/删除成功回调
     */
    handleSuccess() {
      this.pagination.current = 1;
      this.$nextTick(() => {
        this.getList();
        this.$message.success("操作成功");
      });
    },

    /**
     * 分页每页条数切换
     */
    handleSizeChange(val) {
      this.pagination.size = val;
      this.getList();
    },

    /**
     * 分页页码切换
     */
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getList();
    },

    /**
     * 表格行点击
     */
    handleRowClick(row) {
      console.log("点击行数据：", row);
    },
  },
};
</script>

<style lang="scss" scoped>
.property-right-registration-container {
  padding: 20px;
  margin: 0;
  background-color: #f5f7fa;
  min-height: calc(100vh - 60px);

  .search-wrapper {
    margin-bottom: 20px;
    background: #fff;
    .el-row {
      margin-bottom: 10px;
    }
    .mt-20 {
      margin-top: 20px;
    }
    :deep(.el-input),
    :deep(.el-select) {
      width: 100%;
    }
  }

  .list-wrapper {
    background: #fff;
    .el-table {
      --el-table-header-text-color: #303133;
      --el-table-row-hover-bg-color: #f8f9fa;
    }
    .el-pagination {
      margin-top: 20px;
      text-align: right;
    }
    .no-data-tip {
      text-align: center;
      padding: 60px 0;
      color: #909399;
      i {
        font-size: 48px;
        margin-bottom: 10px;
        display: block;
        color: #c0c4cc;
      }
      p {
        font-size: 14px;
        margin: 0;
      }
    }
  }

  .el-tag {
    font-size: 12px;
    padding: 2px 8px;
  }

  .el-table__empty-text {
    color: #606266;
    font-size: 14px;
    padding: 60px 0;
  }

  .flex {
    display: flex;
  }
  .justify-between {
    justify-content: space-between;
  }
  .items-center {
    align-items: center;
  }
  .ml-2 {
    margin-left: 8px;
  }
  .mt-20 {
    margin-top: 20px;
  }
}

::v-deep .el-pagination {
  .el-pager li {
    margin: 0 2px;
  }
  .el-pagination__sizes {
    margin-right: 10px;
  }
}
::v-deep .el-loading-mask {
  .el-loading-spinner {
    top: 50%;
    margin-top: -25px;
  }
}
</style>
